import { SiCivicrm } from "react-icons/si";
import { LuListTree } from "react-icons/lu";
import { TbBuildingFactory2 } from "react-icons/tb";

const sidebar = [
  {
    titleKey: "nav.home",
    title: "Home",
    icon: <SiCivicrm />,
    link: '/production/home'
  },
  {
    titleKey: "sidebar.billsOfMaterials",
    title: "Bills of Materials",
    icon: <LuListTree />,
    link: '/production/bills-of-materials',
    permission: 'production.boms.view'
  },
  {
    titleKey: "sidebar.productionOrders",
    title: "Production Orders",
    icon: <TbBuildingFactory2 />,
    link: '/production/orders',
    permission: 'production.orders.view'
  }
];

export default sidebar;
